var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.98,
    height: 16.981,
    viewBox: "0 0 16.98 16.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4e4e4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.547 4.435)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M349.012,133.864a.5.5,0,1,0,0,.7A.493.493,0,0,0,349.012,133.864Z",
    transform: "translate(-348.161 -133.716)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.622 6.545)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M200.521,197.5a.5.5,0,1,0,0,.7A.493.493,0,0,0,200.521,197.5Z",
    transform: "translate(-199.669 -197.355)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.326 11.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.734,346a.5.5,0,1,0,0,.7A.492.492,0,0,0,221.734,346Z",
    transform: "translate(-220.882 -345.848)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.612,16.52l-1.126-4.5a1.584,1.584,0,0,0-.106-.274L13.39,13.734a1.492,1.492,0,1,1-.7-.7l1.991-1.991a1.584,1.584,0,0,0-.274-.106L9.9,9.808a1.5,1.5,0,0,0-1.421.394L.438,18.243a1.49,1.49,0,0,0,0,2.111l5.628,5.628a1.49,1.49,0,0,0,2.111,0l8.041-8.041A1.5,1.5,0,0,0,16.612,16.52ZM6.066,15.429a1.492,1.492,0,1,1,0,2.111A1.49,1.49,0,0,1,6.066,15.429Zm2.814,7.035a1.492,1.492,0,1,1,0-2.111A1.49,1.49,0,0,1,8.881,22.465Zm1.814-3.375-6.332.7a.5.5,0,1,1-.11-.989l6.332-.7a.5.5,0,1,1,.11.989Z",
    transform: "translate(0 -9.764)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.678)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M444.715.148a.493.493,0,0,0-.7,0L442.56,1.6a1.426,1.426,0,0,1,.7.7L444.715.851A.493.493,0,0,0,444.715.148Z",
    transform: "translate(-442.56 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.f0e9374f2b295654beac6820144e7cbe.svg";
export { ForwardRef as ReactComponent };